// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".day-selector-container{display:flex;justify-content:space-between;align-items:center;padding:10px 15px;width:1000px;max-width:98%}.day-selector-container .day-selector{font-size:1.2em;font-weight:bold;margin:0 10px}.paging-arrow{width:20px;height:20px;cursor:pointer;vertical-align:middle}.paging-arrow.right{transform:rotate(180deg);-webkit-transform:rotate(180deg)}.rate-box{display:flex;align-items:center;gap:15px}.rate-box .box{width:60px}", ""]);
// Exports
module.exports = exports;
